import { BTN_RESET_CLASS, SUCCESS_DAILY_LIMIT } from '../constants';
import CLOCK_IMAGE from '../../../assets/images/time-nyang/clock.gif';
import CAT_TIME_IMAGE from '../../../assets/images/time-nyang/cat-time.png';

export default function TimeNyangGamePanel({
  playState,
  timerText,
  startButtonBg,
  startButtonLabel,
  isStartButtonDisabled,
  dailySuccessCount,
  onStartButtonClick,
}) {
  const clockImage = playState === 'running' ? CLOCK_IMAGE : CAT_TIME_IMAGE;

  return (
    <section className="mt-7 flex flex-col items-center">
      <img src={clockImage} alt="타임냥 시계" className="h-[202px] w-[202px]" />
      <p
        className="mt-3 w-[308px] text-center font-['Pretendard'] text-[64px] font-black leading-none tracking-[-0.5px] text-white tabular-nums"
        style={{ fontVariantNumeric: 'tabular-nums' }}
      >
        {timerText}
      </p>
      <button
        type="button"
        className={`${BTN_RESET_CLASS} mt-3 flex items-center justify-center`}
        onClick={onStartButtonClick}
        style={{
          width: '274px',
          height: '60px',
          borderRadius: '10px',
          border: '1px solid #FFFFFF',
          backgroundColor: startButtonBg,
          paddingTop: '16px',
          paddingBottom: '16px',
          color: '#FFFFFF',
          fontSize: '16px',
          fontWeight: 700,
          lineHeight: 1.4,
          textAlign: 'center',
        }}
        disabled={isStartButtonDisabled}
        aria-label={`타임냥 시작 버튼 성공 ${dailySuccessCount}/${SUCCESS_DAILY_LIMIT}`}
      >
        {startButtonLabel}
      </button>
    </section>
  );
}
